import fetch from './fetch';
import storage from './storage';

export default {
  fetch,
  storage,
};
